import { SnackbarProvider, useSnackbar } from 'notistack';
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Axios from "axios";
import Brackground from "../../../components/Background";
import Container from "../../../components/Container";
import Header from "../../../components/Header";
import Input from "../../../components/Input";
import Navbar from "../../../components/Navbar";
import React from "react";
import Select from "../../../components/select";
import SubmitButton from "../../../components/Button";
import moment from "moment";
import style from "./RelatorioPeriodo.module.css"
import { useStepContext } from "@mui/material";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import LogoSetPort from './LOGO_SETPORT.png';
import { format } from 'date-fns';
import {
    Modal,
    Box,
    Button,
    Typography,
} from "@mui/material";

const RelatorioPeriodo = () => {

    useEffect(() => {
        getEquipamentos();
        getMoegas();
        getPeriodos();
        getBercos();
        VerificaPeriodo();
        getOp()
        getPeriodo()
        DadosDashboard();
        getVeiculos();
        VerificaParalisacao();
    }, [])

    const { id } = useParams();
    const [busca, setBusca] = useState("");
    const [existeParalisacao, setExisteParalisacao] = useState(0);
    const [dadosDash, setDadosDash] = useState([]);
    const [veiculos, setVeiculos] = useState([]);
    const [paralisacoes, setParalisacoes] = useState([]);
    const [descarregado, setDescarregado] = useState([]);
    const [relatorios, setRelatorios] = useState([]);
    const [i, setI] = useState({});
    const [peso2, setPeso2] = useState("");
    const [data, setData] = useState("");
    const [obsPesagem, setObsPesagem] = useState("");
    const [pesobruto, setPesoBruto] = useState("");
    const [databruto, setDataBruto] = useState("");
    const [navioslist, setNaviosList] = useState([])
    const [equipamento, setEquipamento] = useState("");
    const [periodo, setPeriodo] = useState([]);
    const [berco, setBerco] = useState("");
    const [qtbordo, setQtBordo] = useState("");
    const [qtterra, setQtTerra] = useState("");
    const [gerador, setGerador] = useState("");
    const [grab, setGrab] = useState("");
    const [porao, setPorao] = useState("");
    const [requisicao, setRequisicao] = useState("");
    const [conexo, setConexo] = useState("");
    const [inicio, setInicio] = useState("");
    const [existePeriodo, setExistePeriodo] = useState(0);
    const usuario = JSON.parse(localStorage.getItem("user_token")).id;
    const [operacoes, setOperacoes] = useState([]);
    const [equipamentos, setEquipamentos] = useState([]);
    const [periodos, setPeriodos] = useState('');
    const [autos, setAutos] = useState([]);
    const [documentos, setDocumentos] = useState([]);
    const [moegas, setMoegas] = useState([]);
    const [hora, setHora] = useState([]);
    const [paralisacao, setParalisacao] = useState([]);
    const [moega, setMoega] = useState([]);
    const [bercos, setBercos] = useState([])
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [buttonText, setButtonText] = useState('Cadastrar');
    const [filterType, setFilterType] = useState("NOME_MOTORISTA");
    const [openDDSModal, setOpenDDSModal] = useState(false);
    const handleOpenDDSModal = () => setOpenDDSModal(true);
    const handleCloseDDSModal = () => setOpenDDSModal(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [file, setFile] = useState(null);
    const [filter, setFilter] = useState("");
    const [seqPeriodoOp, setSeqPeriodoOp] = useState(null);
    const [selectedSeqPeriodoOp, setSelectedSeqPeriodoOp] = useState(null);


    // Estado para controlar a exibição do modal
    const [openModal, setOpenModal] = useState(false);
    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);

    // Função para lidar com o envio de dados para SUPERVIA
    const handleSendToSupervia = () => {
        // Desabilitar o botão SUPERVIA ao clicar em "Sim"
        setIsButtonDisabled(true);

        // Primeiro, realizar a requisição para pegar os resultados necessários
        Axios.post(`https://operacao.setlogistica.com.br/api/periodo/supervia/${id}`, {
            data: relatorios // Passando 'relatorios' como 'data' conforme especificado
        })
            .then((response) => {
                // Armazenar os dados do resultado
                const resultado = response.data;

                // Verifique se há resultado
                if (!resultado || resultado.length === 0) {
                    enqueueSnackbar('Nenhum dado encontrado para o período especificado.', { variant: 'warning' });
                    setIsButtonDisabled(false); // Reativar o botão caso não haja resultado
                    return;
                }

                // Armazenar os dados necessários
                const corteOutroOperador = resultado.some((item) => item.CORTE_OUTRO_OPERADOR === 'S');
                const nomeNavio = resultado[0]?.NOME_NAVIO;
                const iniPeriodo = resultado[0]?.INI_PERIODO;
                const fimPeriodo = resultado[0]?.FIM_PERIODO;
                const seqPeriodoOP = resultado[0]?.SEQ_PERIODO_OP;
                const codOperacao = resultado[0]?.COD_OPERACAO;
                const dataIniPeriodo = resultado[0]?.DAT_INI_PERIODO;
                const dataFimPeriodo = resultado[0]?.DAT_FIM_PERIODO;
                const usuario = JSON.parse(localStorage.getItem("user_token")).id; // Obter o ID do usuário

                // Verificar se há CORTE_OUTRO_OPERADOR = 'S' e, se sim, acionar a rota de corte operador
                if (corteOutroOperador) {
                    if (!nomeNavio || !iniPeriodo || !fimPeriodo || !seqPeriodoOP || !codOperacao) {
                        enqueueSnackbar('Erro: Dados insuficientes para acionar o corte do operador.', { variant: 'error' });
                        setIsButtonDisabled(false); // Reativar o botão caso ocorra erro
                        return;
                    }

                    // Chamar a rota /supervia/corteoperador com o nome do navio e outras informações necessárias
                    Axios.post(`https://operacao.setlogistica.com.br/api/supervia/corteoperador`, {
                        NOME_NAVIO: nomeNavio,
                        INI_PERIODO: iniPeriodo,
                        FIM_PERIODO: fimPeriodo,
                        SEQ_PERIODO_OP: seqPeriodoOP,
                        COD_OPERACAO: codOperacao,
                        DAT_INI_PERIODO: dataIniPeriodo,
                        DAT_FIM_PERIODO: dataFimPeriodo,
                        DATA: relatorios, // Passar também o período de data, se necessário
                        USUARIO: usuario // Adicionar o campo de usuário
                    })
                        .then(() => {
                            enqueueSnackbar('Corte por outro operador enviado para SUPERVIA com sucesso', { variant: 'success' });
                        })
                        .catch((error) => {
                            console.error("Erro ao enviar para /supervia/corteoperador:", error);
                            enqueueSnackbar('Erro ao enviar corte por outro operador', { variant: 'error' });
                            setIsButtonDisabled(false); // Reativar o botão caso ocorra erro
                        });
                } else {
                    // Se não houver corte por outro operador, considerar o envio bem-sucedido
                    enqueueSnackbar('Dados enviados para SUPERVIA com sucesso', { variant: 'success' });
                }
            })
            .catch((error) => {
                console.error("Erro ao obter dados de /periodo/supervia:", error);
                enqueueSnackbar('Erro ao obter dados para envio', { variant: 'error' });
                setIsButtonDisabled(false); // Reativar o botão caso ocorra erro
            })
            .finally(() => {
                handleCloseModal(); // Fecha o modal após o clique em "Sim", mesmo que ocorra algum erro
            });
    };


    // Função para exibir o modal de confirmação de envio para SUPERVIA
    const showModal = () => {
        handleOpenModal();
    }

    const navigate = useNavigate();

    const getOp = () => {
        Axios.get('https://operacao.setlogistica.com.br/api/relatorios/operacoes').then((response) => {
            setNaviosList(response.data)
        });
    }

    const getDate = () => {
        const date = new Date()
        date.setHours(date.getHours() - 3)
        return (date.toISOString().slice(0, 19).replace('T', ' '))
    }

    const getEquipamentos = () => {
        Axios.get('https://operacao.setlogistica.com.br/api/equipamentos').then((response) => {
            setEquipamentos(response.data)
        });
    }

    const getMoegas = () => {
        Axios.get(`https://operacao.setlogistica.com.br/api/periodo/moega/${id}`, {
            data: relatorios
        }).then((response) => {
            console.log(response.data);
            setMoegas(response.data);
        });
    }

    const getPeriodos = () => {
        Axios.get('https://operacao.setlogistica.com.br/api/periodos/horarios').then((response) => {
            setPeriodos(response.data)
        });
    }

    const getBercos = () => {
        Axios.get('https://operacao.setlogistica.com.br/api/bercos').then((response) => {
            setBercos(response.data);
        });
    }

    const { enqueueSnackbar } = useSnackbar();

    const showAlert = (txt, variant) => {
        enqueueSnackbar(txt, { variant: variant });
    }

    const VerificaPeriodo = () => {
        Axios.get(`https://operacao.setlogistica.com.br/api/periodo/busca/${id}`,)
            .then(function (res) {
                setExistePeriodo(res.data[0].EXISTE)
            })
    }

    const getListaDocumentoDoc = async (id) => {
        try {
            const response = await Axios.get(`https://operacao.setlogistica.com.br/api/documento/lista/${id}`);
            if (response.status === 200) {
                // Supondo que você tenha um estado para armazenar a lista de documentos
                setDocumentos(response.data); // Atualiza o estado documentos com os dados da resposta
            } else {
            }
        } catch (error) {
            console.error('Erro ao obter a lista de documentos:', error);
        }
    };

    const getOperacoes = () => {
        getAutos()
        getDocumentos()
        getMoegas();
        getHora()
        getParalisacao()
        getMoega()
        console.log(autos)
        console.log(documentos)
        Axios.post(`https://operacao.setlogistica.com.br/api/periodo/carregamentos/${id}`, {
            data: relatorios
        }).then((response) => {
            console.log(response.data);
            setOperacoes(response.data);
        });
    }

    useEffect(() => {
        if (relatorios && selectedSeqPeriodoOp) {
            getOperacoes();
        }
    }, [relatorios, selectedSeqPeriodoOp]);

    const getAutos = () => {
        Axios.post(`https://operacao.setlogistica.com.br/api/periodo/autos/${id}`, {
            data: relatorios
        }).then((response) => {
            console.log(response.data);
            setAutos(response.data);
        });
    }

    const getDocumentos = () => {
        Axios.post(`https://operacao.setlogistica.com.br/api/periodo/documentos/${id}`, {
            data: relatorios
        }).then((response) => {
            console.log(response.data);
            setDocumentos(response.data);
        });
    }

    const getHora = () => {
        Axios.post(`https://operacao.setlogistica.com.br/api/periodo/horahora/${id}`, {
            data: relatorios
        }).then((response) => {
            console.log(response.data);
            setHora(response.data);
        });
    }

    const getParalisacao = () => {
        // Limpa o estado das paralisações antes de buscar os novos dados
        setParalisacao([]);

        Axios.post(`https://operacao.setlogistica.com.br/api/periodo/paralisacao/${id}`, {
            data: relatorios
        }).then((response) => {
            console.log(response.data);
            // Atualiza o estado com os novos dados de paralisação
            setParalisacao(response.data);
        }).catch((error) => {
            console.error("Erro ao buscar as paralisações:", error);
            setParalisacao([]); // Em caso de erro, mantém o estado vazio
        });
    };


    const getMoega = () => {
        Axios.post(`https://operacao.setlogistica.com.br/api/periodo/moega/${id}`, {
            data: relatorios
        }).then((response) => {
            console.log(response.data);
            setMoega(response.data);
        });
    }

    const addPeriodo = async () => {
        await Axios.post('https://operacao.setlogistica.com.br/api/periodo/criar', {
            operacao: id,
            periodo: periodo,
            inicio: inicio,
            berco: berco,
            qtbordo: qtbordo,
            qtterra: qtterra,
            porao: porao,
            moega: equipamento,
            conexo: conexo,
            requisicao: requisicao,
            gerador: gerador,
            grab: grab,
            usuario: usuario,
            dtcadastro: getDate()
        })
            .then(function (res) {
                console.log(res);
                res.data.sqlMessage ?
                    showAlert(res.data.sqlMessage, 'error') :
                    showAlert('Nova Operação cadastrada com sucesso', 'success');
                setTimeout(() => {
                    navigate(`/operacao/${id}`)
                }, 2000);
            })
    }

    const validaDados = async () => {
        if (!grab | !periodo | !qtterra | !berco | !gerador | !equipamento | !qtbordo | !porao | !inicio) {
            showAlert('Preencha todos os campos!', 'error')
            return;
        }

        //addPeriodo() 
        setButtonText('Aguarde...');
        setIsButtonDisabled(true);

        try {
            await addPeriodo();
        } catch (error) {
            console.log(error);
            showAlert('Ocorreu um erro ao cadastrar a nova operação', 'error');
        } finally {
            setButtonText('Enviar');
            setIsButtonDisabled(false);
        }
    }

    //modal de 2 pesagem
    const [openA, setOpenA] = useState(false);
    const AbrirPesagem = () => {
        setOpenA(true);
    };
    const FecharPesagem = () => {
        setOpenA(false);
    };

    const [openB, setOpenB] = useState(false);
    const AbrirConfirm = () => {
        setOpenB(true);
    };
    const FecharConfirm = () => {
        setOpenB(false);
    };

    const [MostaInput, setMostaInput] = useState(false);

    const divClick = () => {
        setMostaInput(true);
    };

    const getPeriodo = () => {
        Axios.get(`https://operacao.setlogistica.com.br/api/periodos/gerais/${id}`).then((response) => {
            setPeriodo(response.data); // Armazena os períodos disponíveis
        });
    }

    const VerificaParalisacao = () => {
        Axios.get(`https://operacao.setlogistica.com.br/api/verifica/paralisacao/${id}`,)
            .then(function (res) {
                setExisteParalisacao(res.data)
            })
    }
    const DadosDashboard = () => {
        Axios.get(`https://operacao.setlogistica.com.br/api/periodo/dashboard/${id}`)
            .then(function (res) {
                setDadosDash(res.data[0]);
                const seqPeriodo = res.data[0]?.SEQ_PERIODO_OP; // Obtenha o SEQ_PERIODO_OP
                setSeqPeriodoOp(seqPeriodo); // Armazena no estado

                // Verificar se existe documento para o SEQ_PERIODO_OP
                verificarDocumento(seqPeriodo);

                // Pegar as paralisacoes para o período
                Axios.get(`https://operacao.setlogistica.com.br/api/paralisacao/periodo/${seqPeriodo}`)
                    .then(function (res) {
                        setParalisacoes(res.data);
                    });
            });
    };


    const getVeiculos = () => {
        Axios.get(`https://operacao.setlogistica.com.br/api/ultimapesagem/busca/${id}`,)
            .then(function (res) {
                setVeiculos(res.data)
            })
    }

    const downloadNota = async (idCarregamento) => {
        const data = {
            idCarregamento: idCarregamento
        };

        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `https://operacao.setlogistica.com.br/api/baixarnota`,
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
            data: data
        };

        Axios.request(config)
            .then((res) => {
                var byteCharacters = atob(res.data.pdf.split(',')[res.data.pdf.split(',').length - 1]);
                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                var byteArray = new Uint8Array(byteNumbers);
                var file = new Blob([byteArray], { type: res.data.pdf.split(',')[0].split(":")[1] });

                const url = URL.createObjectURL(file);
                const link = document.createElement('a');
                link.href = url;
                link.download = res.data.filename
                link.click();
                URL.revokeObjectURL(url);
            })
            .catch((err) => {
                showAlert('Erro ao obter PDF', 'error')
                console.log(err.response.data.mensagem)
            })
    }

    const LOGO_BASE64 = "data:image/png;base64,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";

    const downloadTicket = (carregamento) => {
        const doc = new jsPDF({
            orientation: 'portrait',
            unit: 'cm',
            format: [13, 7]
        });

        // Adiciona o logo diretamente no PDF usando a string base64
        doc.addImage(LOGO_BASE64, 'PNG', 0.5, 0.8, 2.8, 0.8); // Ajuste a posição e o tamanho conforme necessário

        // Cabeçalho e informações de endereço
        doc.setFontSize(6.5);
        doc.text("Praça dos Expedicionários, 19", 3, 0.5);
        doc.text("Sala 53 - Santos/SP", 4.1, 1);

        // Título e número do ticket
        doc.setFontSize(11);
        doc.text(`Ticket de Pesagem Nº ${carregamento.ID_CARREGAMENTO}`, 1, 2.3);

        // Informações do cliente e veículo
        doc.setFontSize(9);
        doc.setFont("Helvetica", "bold");
        doc.text("MOTORISTA:", 0.5, 3);
        doc.setFont("Helvetica", "normal");
        doc.text(`${carregamento.NOME_MOTORISTA}`, 2.6, 3);

        doc.setFont("Helvetica", "bold");
        doc.text("CAVA.:", 0.5, 3.5);
        doc.setFont("Helvetica", "normal");
        doc.text(`${carregamento.PLACA_CAVALO || "N/A"}`, 1.8, 3.5);

        doc.setFont("Helvetica", "bold");
        doc.text("CAR.1:", 3.7, 3.5);
        doc.setFont("Helvetica", "normal");
        doc.text(`${carregamento.PLACA_CARRETA || "N/A"}`, 4.9, 3.5);

        doc.setFont("Helvetica", "bold");
        doc.text("CAR.2:", 0.5, 4);
        doc.setFont("Helvetica", "normal");
        doc.text(`${carregamento.PLACA_CARRETA2 || "N/A"}`, 1.8, 4);

        doc.setFont("Helvetica", "bold");
        doc.text("CAR.3:", 3.7, 4);
        doc.setFont("Helvetica", "normal");
        doc.text(`${carregamento.PLACA_CARRETA3 || "N/A"}`, 4.9, 4);

        doc.setFont("Helvetica", "bold");
        doc.text("NAVIO:", 0.5, 5);
        doc.setFont("Helvetica", "normal");
        doc.text(`${carregamento.NOME_NAVIO}`, 2.5, 5);

        doc.setFont("Helvetica", "bold");
        doc.text("DI:", 0.5, 5.5);
        doc.setFont("Helvetica", "normal");
        doc.text(`${carregamento.NUMERO_DOC}`, 2.5, 5.5);

        doc.setFont("Helvetica", "bold");
        doc.text("PEDIDO:", 0.5, 6);
        doc.setFont("Helvetica", "normal");
        doc.text(`${carregamento.PEDIDO_MIC} - ${carregamento.NOME_DESTINO}`, 2.5, 6);

        doc.setFont("Helvetica", "bold");
        doc.text("PRODUTO:", 0.5, 6.5);
        doc.setFont("Helvetica", "normal");
        doc.text(`${carregamento.PRODUTO}`, 2.5, 6.5);

        doc.setFont("Helvetica", "bold");
        doc.text("CLIENTE:", 0.5, 7.5);
        doc.setFont("Helvetica", "normal");
        doc.text(`${carregamento.NOME_CLIENTE}`, 2.1, 7.5);

        doc.setFont("Helvetica", "bold");
        doc.text("TRANSP.:", 0.5, 8);
        doc.setFont("Helvetica", "normal");
        doc.text(`${carregamento.NOME_REDUZIDO_TRANSP}`, 2.1, 8);

        doc.setFont("Helvetica", "bold");
        doc.text("PORÃO:", 0.5, 9);
        doc.setFont("Helvetica", "normal");
        doc.text(`${carregamento.PORAO}`, 2, 9);
        doc.text(`DATA CARREG.: ${moment(carregamento.DATA_CARREGAMENTO).format('DD/MM/YY - HH:mm')}`, 0.5, 9.5);

        doc.setFont("Helvetica", "bold");
        doc.setFontSize(13);
        doc.text(`PESO MOEGA: ${carregamento.PESO_CARREGADO.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} Kg`, 0.5, 10.5);

        doc.text(`.`, 0.5, 12);

        // Salvar o PDF
        doc.save(`ticket_pesagem_${carregamento.ID_CARREGAMENTO}.pdf`);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return isNaN(date) ? 'Data inválida' : format(date, 'dd/MM - HH:mm');
    };

    const exportRelatorioPDF = () => {
        const doc = new jsPDF();

        // Função para adicionar o cabeçalho em cada página
        const addHeader = (doc, isFirstPage) => {
            if (isFirstPage) {
                doc.addImage(LogoSetPort, 'PNG', 10, 10, 40, 10);
            }
            doc.setFontSize(10); // Define o tamanho da fonte para corresponder ao conteúdo da tabela

            const headerText = `Relatório Período: ${relatorios}`;
            doc.text(headerText, isFirstPage ? 70 : 10, isFirstPage ? 20 : 10);

            // Adicionar informações adicionais no cabeçalho usando autoTable
            if (isFirstPage) {
                const tableData = autos.map(val => ({
                    totalAutos: `Autos: ${val.QTDE_AUTOS}`,
                    pesoHibrido: `Peso: ${(val.PESO_HIBRIDO / 1000).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} Tons`
                }));

                // Extraindo uma única entrada de autos para criar a tabela de totais
                const totalAutos = tableData.length > 0 ? tableData[0].totalAutos : 'Autos: 0';
                const pesoHibrido = tableData.length > 0 ? tableData[0].pesoHibrido : 'Peso: 0 Tons';

                doc.autoTable({
                    head: [['TOTAL', '']],
                    body: [
                        [totalAutos, ''],
                        [pesoHibrido, '']
                    ],
                    startY: 30,
                    theme: 'plain',
                    headStyles: {
                        fillColor: [0, 29, 79], // Azul
                        textColor: [255, 255, 255], // Branco
                        fontSize: 10,
                        fontStyle: 'bold'
                    },
                    bodyStyles: {
                        fontSize: 10
                    },
                    styles: {
                        cellPadding: 2
                    },
                    columnStyles: {
                        0: { cellWidth: 50 }, // Ajuste o valor conforme necessário para o tamanho do texto
                        1: { cellWidth: 10 } // Segunda coluna com largura mínima
                    }
                });
            }
        };

        // Inicializar o cabeçalho para a primeira página
        addHeader(doc, true);

        // Adicionar a tabela principal
        const tableColumn = ["#", "ID", "Nome", "Placa do Cavalo", "Peso Líquido", "DI", "Data Carregado"];
        const tableRows = [];

        operacoes.forEach((val, index) => {
            const rowData = [
                index + 1,
                val.ID_CARREGAMENTO,
                val.NOME_MOTORISTA,
                val.PLACA_CAVALO,
                val.PESO_LIQUIDO.toLocaleString(undefined, { maximumFractionDigits: 2 }),
                val.DOCUMENTO,
                formatDate(val.DATA_CARREGAMENTO)
            ];
            tableRows.push(rowData);
        });

        doc.autoTable({
            head: [tableColumn],
            body: tableRows,
            startY: 55,
            didDrawPage: (data) => {
                // Adicionar o cabeçalho em cada página sem o logo
                if (data.pageNumber > 1) {
                    addHeader(doc, false);
                }
            },
            theme: 'striped',
            headStyles: {
                fontSize: 10, // Correspondência de tamanho da fonte com o cabeçalho
                fillColor: [0, 29, 79], // Azul
                textColor: [255, 255, 255] // Branco
            },
            bodyStyles: {
                fontSize: 10 // Correspondência de tamanho da fonte com o cabeçalho
            }
        });

        doc.save('relatorio_periodo.pdf');
    };



    const handleFilterChange = (e) => {
        setFilter(e.target.value);
    };

    const handleFilterTypeChange = (e) => {
        setFilterType(e.target.value);
    };

    const filteredOperacoes = operacoes.filter((operacao) => {
        const filterLowerCase = filter.toLowerCase();
        switch (filterType) {
            case "NOME_MOTORISTA":
                return operacao.NOME_MOTORISTA.toLowerCase().includes(filterLowerCase);
            case "PLACA_CAVALO":
                return operacao.PLACA_CAVALO.toLowerCase().includes(filterLowerCase);
            case "DOCUMENTO":
                return operacao.REFERENCIA.toLowerCase().includes(filterLowerCase);
            case "NOME_CLIENTE":
                return operacao.NOME_CLIENTE.toLowerCase().includes(filterLowerCase);
            case "NOME_REDUZIDO_TRANSP":
                return operacao.NOME_REDUZIDO_TRANSP.toLowerCase().includes(filterLowerCase);
            case "PLACA_CARRETA":
                return (
                    (operacao.PLACA_CARRETA && operacao.PLACA_CARRETA.toLowerCase().includes(filterLowerCase)) ||
                    (operacao.PLACA_CARRETA2 && operacao.PLACA_CARRETA2.toLowerCase().includes(filterLowerCase)) ||
                    (operacao.PLACA_CARRETA3 && operacao.PLACA_CARRETA3.toLowerCase().includes(filterLowerCase))
                );
            default:
                return true;
        }
    });

    const handleDocumentSubmit = async (e) => {
        e.preventDefault(); // Previne o comportamento padrão de envio do formulário

        if (!file) {
            showAlert("Selecione um arquivo antes de enviar.", 'error');
            return;
        }

        if (!selectedSeqPeriodoOp) {
            showAlert("O período da operação não foi encontrado.", 'error');
            return;
        }

        const usuario = JSON.parse(localStorage.getItem("user_token")).id; // Obtenha o ID do usuário logado
        const formData = new FormData();
        formData.append('file', file); // Adiciona o arquivo PDF
        formData.append('codListaDocumento', 6); // Cod_lista_documento fixo como 6
        formData.append('codOperacao', id); // Use o `id` diretamente, que é o valor de `COD_OPERACAO`
        formData.append('nomeNavio', i.NOME_NAVIO); // Nome do navio (se necessário)
        formData.append('usuarioDocumento', usuario); // ID do usuário responsável
        formData.append('seqPeriodoOp', selectedSeqPeriodoOp); // Adiciona o SEQ_PERIODO_OP selecionado

        try {
            const response = await Axios.post('https://operacao.setlogistica.com.br/api/documento/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.status === 200) {
                showAlert('Documento adicionado com sucesso!', 'success');
                getListaDocumentoDoc(id); // Atualiza a lista de documentos usando `id`
                handleCloseDDSModal(); // Fecha o modal após o sucesso
            } else {
                showAlert('Documento adicionado com sucesso!', 'success');
            }
        } catch (error) {
            console.error('Erro ao adicionar o documento:', error);

        }
    };


    const [isDDSEnabled, setIsDDSEnabled] = useState(false); // Inicializa como "false" para ser desabilitado até que a verificação seja feita

    const verificarDocumento = (seqPeriodoOp) => {
        Axios.get(`https://operacao.setlogistica.com.br/api/documento/existe/${seqPeriodoOp}`)
            .then((response) => {
                console.log('Documento existe:', response.data.exists);
                setIsDDSEnabled(!response.data.exists); // Habilita o botão se não existir documento
            })
            .catch((error) => {
                console.error('Erro ao verificar documento:', error);
                setIsDDSEnabled(true); // Em caso de erro, mantemos o botão habilitado
            });
    };

    return (
        <>
            <Navbar relatorios />
            <Header />
            <Brackground />
            <Container>
                <div className={style.content}>
                    <div className={style.nav}>
                        <div className={style.navItem} onClick={() => navigate(`/relatoriocliente`)}>
                            Selecione um navio
                        </div>
                        <div className={style.navItem} onClick={() => navigate(`/relatoriocliente/operacao/${id}`)}>
                            Relatório (Operação)
                        </div>
                        <div className={style.navItemActive}>
                            {'>'}  Relatório (Período)
                        </div>
                    </div>

                    <div className={style.container}>
                        <div className={style.formulario}>
                            <section className={style.filters}>
                                <p> <center> <b><i class="fas fa-ship"></i>&nbsp;&nbsp;&nbsp;{dadosDash.NOME_NAVIO || "--"}</b> </center> </p>
                                <div className={style.formControl}>

                                    <select
                                        onChange={(e) => {
                                            const selectedPeriodo = periodo.find(val => val.PERIODO === e.target.value);

                                            if (selectedPeriodo) {
                                                // Atualiza os estados necessários
                                                setRelatorios(e.target.value);
                                                setSelectedSeqPeriodoOp(selectedPeriodo.SEQ_PERIODO_OP);

                                                // Chama verificarDocumento
                                                verificarDocumento(selectedPeriodo.SEQ_PERIODO_OP);
                                            } else {
                                                console.error("Nenhum período correspondente encontrado.");
                                            }
                                        }}
                                    >
                                        <option disabled selected>Selecione uma opção</option>
                                        {periodo?.map(val => (
                                            <option key={val.SEQ_PERIODO_OP} value={val.PERIODO}>
                                                {val.PERIODO}
                                            </option>
                                        ))}
                                    </select>

                                </div>

                                <div className={style.selectedPeriod}>
                                    <table className={style.moegaTable}>
                                        <tbody>
                                            {moega.map((val, index) => (
                                                <tr key={index}>
                                                    <td className={style.centered}>
                                                        <div><b>{relatorios}</b> - {val.TERNO} Terno</div>
                                                        <div>{val.MOEGA_1} - Porão {val.PORAO_01}</div>
                                                        {val.MOEGA_2 && val.PORAO_02 &&
                                                            <div>{val.MOEGA_2} - Porão {val.PORAO_02}</div>
                                                        }
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                            </section>
                            {moega.some(val => val.CORTE_CHUVA === 'S') ? (
                                <div>
                                    <div className={style.chuvaContainer}>
                                        <i className="fa fa-cloud-rain icon" />&nbsp; &nbsp;
                                        <p>CORTE DE PERÍODO POR CHUVA</p>
                                    </div>
                                    {(usuario === 'lucas') && (
                                        <button
                                            className={style.superviaButton}
                                            onClick={showModal} // Abre o modal ao clicar no botão SUPERVIA
                                        >
                                            SUPERVIA
                                        </button>
                                    )}
                                </div>
                            ) : moega.some(val => val.CORTE_OUTRO_OPERADOR === 'S') ? (
                                <div>
                                    <div className={style.chuvaContainer}>
                                        <i className="fa fa-user-times icon" />&nbsp; &nbsp;
                                        <p>CORTE DE PERÍODO POR OUTRO OPERADOR</p>
                                    </div>
                                    {(usuario === 'lucas') && (
                                        <button
                                            className={style.superviaButton}
                                            onClick={showModal} // Abre o modal ao clicar no botão SUPERVIA
                                            disabled={isButtonDisabled || moega.some(val => val.REGISTRADO_CORTE_OUTRO_OPERADOR === 'S')}
                                        >
                                            SUPERVIA
                                        </button>
                                    )}
                                </div>
                            ) : (
                                <div className={style.cardPara}>
                                    <table className={style.cardParalisacao}>
                                        <thead>
                                            <tr>
                                                <th>Motivo</th>
                                                <th>Ínicio</th>
                                                <th>Término</th>
                                                <th>Duração</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paralisacao.filter((val) => {
                                                if (busca === "") {
                                                    return true;
                                                } else {
                                                    return val.DESC_MOTIVO.includes(busca) ||
                                                        val.OBSERVACO.includes(busca) ||
                                                        val.HORA_INICIO.includes(busca) ||
                                                        val.HORA_TERMINO.includes(busca) ||
                                                        val.DURACAO.includes(busca);
                                                }
                                            }).map((val) => {
                                                return (
                                                    <tr key={val.DESC_MOTIVO}>
                                                        <th className={style.tooltip}>
                                                            {val.DESC_MOTIVO}
                                                            {(val.OBSERVACO) && (
                                                                <th className={style.tooltiptext}>
                                                                    <table className={style.table2}>
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Observação</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <th>{val.OBSERVACO}</th>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </th>
                                                            )}
                                                        </th>
                                                        <th>{val.HORA_INICIO}</th>
                                                        <th>{val.HORA_TERMINO}</th>
                                                        <th>{val.DURACAO}</th>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )}

                        </div>
                        {moega.every(val => val.CORTE_CHUVA !== 'S' && val.CORTE_OUTRO_OPERADOR !== 'S') && (
                            <section className={style.cards}>
                                <div className={style.card}>
                                    <i className="fa fa-truck icon"></i>
                                    <p><b>Carregados</b></p>
                                    {autos.map(val => (
                                        <span className={style.total}>{val.QTDE_AUTOS} Autos</span>
                                    ))}
                                </div>

                                <div className={style.card}>
                                    <i className="fa fa-battery-three-quarters icon"></i>
                                    <p><b>Peso Carregado</b></p>
                                    {autos.map(val => (
                                        <span className={style.total}>
                                            {(val.PESO_HIBRIDO / 1000).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} Tons
                                        </span>
                                    ))}
                                </div>

                                <div className={style.card}>
                                    <i className="fa fa-file-text icon"></i>
                                    <p><b>Peso por DI</b></p>
                                    {documentos.map(val => (
                                        <div className={style.details}>
                                            <span>{val.DOC_CARGA}</span> | {(val.PESO_LIQUIDO_CARGA / 1000).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} Tons | {val.QTDE_AUTOS_CARGA} Autos
                                        </div>
                                    ))}
                                </div>

                                <div className={style.card}>
                                    <i className="fa fa-clock-o icon"></i>
                                    <p><b>Hora / Hora</b></p>
                                    {hora
                                        .sort((a, b) => {
                                            // Se a hora for '0 h às 1 h', movemos para o final
                                            if (a.HORA === '0 h às 1 h') return 1;
                                            if (b.HORA === '0 h às 1 h') return -1;
                                            return a.HORA.localeCompare(b.HORA);
                                        })
                                        .map(val => {
                                            // Formatar a hora para dois dígitos
                                            const formattedHora = val.HORA.replace(/(\d+)/g, match => match.padStart(2, '0'));

                                            return (
                                                <div className={style.details} key={val.HORA}>
                                                    <b>{formattedHora}</b> | {val.QUANTIDADE_AUTOS} Autos
                                                </div>
                                            );
                                        })}
                                </div>

                            </section>
                        )}
                        {moega.every(val => val.CORTE_CHUVA !== 'S' && val.CORTE_OUTRO_OPERADOR !== 'S') && (

                            <section className={style.search}>

                                <div className={style.searchBox}>
                                    <select value={filterType} onChange={handleFilterTypeChange}>
                                        <option value="NOME_MOTORISTA">Motorista</option>
                                        <option value="NOME_CLIENTE">Recebedor</option>
                                        <option value="PLACA_CAVALO">Placa do Cavalo</option>
                                        <option value="PLACA_CARRETA">Placa da Carreta</option>
                                        <option value="DOCUMENTO">DI/BL</option>
                                        <option value="NOME_REDUZIDO_TRANSP">Transportadora</option>
                                    </select>
                                    <input
                                        type="text"
                                        placeholder="Pesquisar..."
                                        value={filter}
                                        onChange={handleFilterChange}
                                    />
                                </div>

                                <div className={style.dataFiltro}>

                                    <i
                                        className={`fa fa-file-pdf ${style.iconButton}`}
                                        onClick={exportRelatorioPDF}
                                    />

                                </div>
                            </section>

                        )}
                    </div>

                    {moega.every(val => val.CORTE_CHUVA !== 'S' && val.CORTE_OUTRO_OPERADOR !== 'S') && (
                        <table className={style.table}>
                            <thead>
                                <tr>
                                    <th className={style.sequencial}>#</th>
                                    <th><abbr title="ID">ID</abbr></th>
                                    <th><abbr title="Nome">Nome</abbr></th>
                                    <th><abbr title="Placa do Cavalo">Placa (Cavalo)</abbr></th>
                                    <th><abbr title="Segundo Peso">Peso (Moega)</abbr></th>
                                    <th><abbr title="Terceiro Peso">Peso (Bruto)</abbr></th>
                                    <th><abbr title="Peso Líquido">Peso Líquido</abbr></th>
                                    <th><abbr title="Documento">DI</abbr></th>
                                    <th><abbr title="Pedido">Pedido</abbr></th>
                                    <th><abbr title="Cliente">Recebedor</abbr></th>
                                    <th><abbr title="Transportadora">Transp.</abbr></th>
                                    <th><abbr title="Data Carregado">Data Carregado</abbr></th>
                                    <th><abbr title="(Liquido - Moega)">Diferença</abbr></th>
                                    <th><abbr title="Ticket">Ticket</abbr></th>
                                    <th><abbr title="Nota">N.F</abbr></th>
                                </tr>
                            </thead>

                            <tbody>
                                {filteredOperacoes.map((val, index) => {
                                    const isStatusSete = val.STATUS_NOTA_MIC === 7;
                                    const notaDownloadClass = [2, 3, 4, 6].includes(val.STATUS_NOTA_MIC)
                                        ? style.nota_download
                                        : style.nota_download_empty;

                                    const rowClasses = `${val.PESO_BRUTO === 0 ? style.yellowbackground : ''} ${isStatusSete ? style.strikethrough : ''}`;

                                    // Definir cor de fundo somente para o <td> da coluna sequencial
                                    let backgroundColor = '';

                                    if (val.PESO_MIC === val.PESO_CARREGADO) {
                                        backgroundColor = 'green'; // Verde se PESO_MIC for igual a PESO_CARREGADO
                                    } else if (val.PESO_MIC === null) {
                                        backgroundColor = 'gray'; // Cinza se PESO_MIC for igual a 0.000
                                    } else if (val.PESO_MIC !== null && val.PESO_MIC !== val.PESO_CARREGADO) {
                                        backgroundColor = 'red'; // Vermelho se PESO_MIC for maior que 0.000 e diferente de PESO_CARREGADO
                                    }

                                    return (
                                        <tr key={val.ID_CARREGAMENTO} className={rowClasses}>
                                            <td className={style.sequencial} style={{ backgroundColor, color: 'white' }}>
                                                {index + 1}
                                            </td> {/* Adiciona a numeração sequencial com cor de fundo */}
                                            <td>{val.ID_CARREGAMENTO}</td>
                                            <td>{val.NOME_MOTORISTA}</td>
                                            <td className={style.tooltip}>
                                                {val.PLACA_CAVALO}
                                                {(val.PLACA_CARRETA || val.PLACA_CARRETA2) && (
                                                    <div className={style.tooltiptext}>
                                                        <table className={style.table2}>
                                                            <thead>
                                                                <tr>
                                                                    <th>Carreta_1</th>
                                                                    <th>Carreta_2</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>{val.PLACA_CARRETA}</td>
                                                                    <td>{val.PLACA_CARRETA2}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )}
                                            </td>
                                            <td>{(val.PESO_CARREGADO).toLocaleString(undefined, { maximumFractionDigits: 2 })}</td>
                                            <td>{(val.PESO_BRUTO).toLocaleString(undefined, { maximumFractionDigits: 2 })}</td>
                                            <td>{(val.PESO_LIQUIDO).toLocaleString(undefined, { maximumFractionDigits: 2 })}</td>
                                            <td>{val.DOCUMENTO}</td>
                                            <td>{val.PEDIDO_MIC}</td>
                                            <td>{val.NOME_CLIENTE}</td>
                                            <td>{val.NOME_REDUZIDO_TRANSP}</td>
                                            <td>{formatDate(val.DATA_CARREGAMENTO)}</td>
                                            <td>{val.DIFERENCA} kg - {val.PERCENTUAL} %</td>
                                            <td>
                                                <i
                                                    onClick={() => downloadTicket(val)}
                                                    style={{ cursor: "pointer", color: "auto" }}
                                                    className="fa fa-file-pdf icon"
                                                />
                                            </td>
                                            <td className={notaDownloadClass}>
                                                <i
                                                    onClick={() => [2, 3, 4, 6].includes(val.STATUS_NOTA_MIC) ? downloadNota(val.ID_CARREGAMENTO) : undefined}
                                                    style={[2, 3, 4, 6].includes(val.STATUS_NOTA_MIC) ? { color: "auto" } : { color: "#bcbcbc" }}
                                                    className="fa fa-file-pdf icon"
                                                />
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}

                    {/* Modal de confirmação do envio de dados para SUPERVIA */}
                    <Modal
                        open={openModal}
                        onClose={handleCloseModal}
                        aria-labelledby="modal-title"
                        aria-describedby="modal-description"
                    >
                        <Box
                            sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: 400,
                                bgcolor: 'background.paper',
                                border: '2px solid #065986',
                                boxShadow: 24,
                                p: 4,
                                textAlign: 'center'
                            }}
                        >
                            <Typography id="modal-title" variant="h6" component="h2">
                                DESEJA ENVIAR OS DADOS PARA SUPERVIA?
                            </Typography>
                            <Box mt={4} display="flex" justifyContent="space-between">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSendToSupervia}
                                >
                                    Sim
                                </Button>
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    onClick={handleCloseModal}
                                >
                                    Não
                                </Button>
                            </Box>
                        </Box>
                    </Modal>

                    <Modal
                        open={openDDSModal} // Estado para abrir/fechar modal
                        onClose={handleCloseDDSModal}
                        aria-labelledby="modal-dds-title"
                        aria-describedby="modal-dds-description"
                    >
                        <Box
                            sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: 400,
                                bgcolor: 'background.paper',
                                border: '2px solid #065986',
                                boxShadow: 24,
                                p: 4,
                                textAlign: 'center'
                            }}
                        >
                            <Typography id="modal-dds-title" variant="h6" component="h2">
                                Enviar Documento PDF (DDS)
                            </Typography>
                            <Box mt={2} sx={{ gap: '25px', justifyContent: 'space-between' }}>
                                <form onSubmit={handleDocumentSubmit}>
                                    <input
                                        type="file"
                                        accept="application/pdf"
                                        onChange={(e) => setFile(e.target.files[0])} // Captura o arquivo PDF
                                        required
                                    />
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        disabled={!file} // Desabilita o botão se não houver arquivo selecionado
                                    >
                                        Enviar
                                    </Button>
                                </form>
                            </Box>
                        </Box>
                    </Modal>


                </div>
            </Container>

        </>
    );
};

export default function IntegrationNotistack() {
    return (
        <SnackbarProvider
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            maxSnack={3}
            autoHideDuration={2500}>
            <RelatorioPeriodo />
        </SnackbarProvider >
    );
}